import { borrowerFirstNames, borrowerLastNames, loanProducts } from '../data/commissions';
import { Loan, Period } from '../types/commission';

/** Small deterministic PRNG so a role/period always renders the same production. */
function seededRandom(seed: number): () => number {
  let state = seed >>> 0;
  return () => {
    state += 0x6d2b79f5;
    let value = Math.imul(state ^ (state >>> 15), 1 | state);
    value ^= value + Math.imul(value ^ (value >>> 7), 61 | value);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  };
}

function hash(value: string): number {
  let result = 0;
  for (let index = 0; index < value.length; index += 1) {
    result = (result << 5) - result + value.charCodeAt(index);
    result |= 0;
  }
  return Math.abs(result);
}

/** Builds the funded-loan list a role is paid on for a given period. */
export function buildLoans(period: Period, roleId: string, count: number): Loan[] {
  const random = seededRandom(hash(`${roleId}-${period.id}`));
  const [year, month] = period.id.split('-').map(Number);
  const lastDay = period.isCurrent ? period.daysElapsed : period.daysTotal;

  return Array.from({ length: count }, (_, index) => {
    const first = borrowerFirstNames[Math.floor(random() * borrowerFirstNames.length)];
    const last = borrowerLastNames[Math.floor(random() * borrowerLastNames.length)];
    const product = loanProducts[Math.floor(random() * loanProducts.length)];
    const amount = Math.round((180000 + random() * 620000) / 100) * 100;
    const day = Math.max(1, Math.min(lastDay, Math.ceil(((index + 1) / count) * lastDay)));

    return {
      id: `LN-${String(hash(`${roleId}${period.id}${index}`) % 90000 + 10000)}`,
      borrower: `${first} ${last}`,
      product,
      fundedDate: `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
      amount,
    };
  }).sort((a, b) => a.fundedDate.localeCompare(b.fundedDate));
}
